import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCheckCircle, faHeart, faLocationDot, faPlane} from '@fortawesome/free-solid-svg-icons'
import "../../App.css";
import {LIKE_COLOUR_LIKED, LIKE_COLOUR_UNLIKED} from "../util/Util";

interface Props {
    displaySessions: boolean;
    displayLikes: boolean;
    sessionCount: number;
    likesCount: number;
    visitCount: number;
    visited: boolean;
    id: string;
    isOpen: boolean;
    toggleVisited: (locationId: string) => void;
}

const getVisitedStyle = (visited: boolean, isOpen: boolean) => {
    if (!isOpen) {
        return 'not-selected font-1dot5em'; // No cursor-pointer for unopened pubs
    } else if(!visited) {
        return 'not-selected cursor-pointer font-1dot5em';
    } else {
        return 'white cursor-pointer font-1dot5em';
    }
}

function VisitElement(props: Props) {

  function getValueToDisplay(): number {
    if(props.displaySessions) {
      return props.sessionCount || 0
    } else if (props.displayLikes) { 
      return props.likesCount || 0
    } else {
      return props.visitCount || 0
    }
  }

    return (
        <div>
            <div className={"text-center"}>
                 <FontAwesomeIcon className={getVisitedStyle(props.visited, props.isOpen)}
                                  onClick={() => props.isOpen && props.toggleVisited(props.id)}
                                  icon={faCheckCircle}
                                  style={{ opacity: props.isOpen ? 1 : 0.3 }} />
            </div>
          <div className={"text-center"}>
            <div className={"d-inline-block"}>{getValueToDisplay()}</div>
            {props.displaySessions && <div className={"text-center d-inline-block"}>
              <small>
                  <FontAwesomeIcon className="ml-1" icon={faLocationDot} />
              </small>
              </div>}
            {props.displayLikes && <div className={"text-center d-inline-block"}>
              <small>
                <FontAwesomeIcon className="ml-1" icon={faHeart} style={{color: props.likesCount > 0 ? LIKE_COLOUR_LIKED : LIKE_COLOUR_UNLIKED}} />
              </small>
            </div>}
          </div>
        </div>
    )
}

export default VisitElement;